import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Invoicereportdetail } from './invoicereportdetail';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class InvoiceReportService {
    private _Invoicereport = CONFIGURATION.baseServiceUrl + 'invoicereportservice/';
    private _ssnUrl = CONFIGURATION.baseServiceUrl + 'SsnInfo/';

    constructor(private _http: Http) { }

    getReportData(): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._Invoicereport + 'invoicereportreferencedata', { headers: headers })
            .map((response: Response) => response.json().invoiceReferenceData)
            .catch(this.handleError);
    }

    getInvoiceReports(filterCriteria: any): Observable<Invoicereportdetail[]> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        const fileName = 'invoicereportdata?TaxYear=' + filterCriteria.selectedYear
            + '&ControlGroup=' + filterCriteria.selectedControlGroup + '&WorkMonth=' + filterCriteria.selectedMonth;
        return this._http.get(this._Invoicereport + fileName, { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getSSnData(ssnData: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        let fileName = 'ssnreportdata?Ssn=' + ssnData.ssn
            + '&TaxYear=' + ssnData.taxyear
            + '&ControlGroup=' + ssnData.controlgroup
            + '&ReportName=' + 'ACABillingReport';
        return this._http.get(this._ssnUrl + fileName, { headers: headers })
            .map((response: Response) => <any>response.json())
            .catch(this.handleError);
    }
    downloadExcelReport(filterCriteria: any): any {
        const fileName = 'excel-download?TaxYear=' + filterCriteria.selectedYear
            + '&ControlGroup=' + filterCriteria.selectedControlGroup + '&WorkMonth=' + filterCriteria.selectedMonth;
        const url = this._Invoicereport + fileName
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(url, { headers: headers, responseType: ResponseContentType.Blob }).map(
            (res) => {
                const a = document.createElement('a');
                document.body.appendChild(a);
                const blob = new Blob([res.blob()], { type: 'application/zip' });
                const downloadUrl = URL.createObjectURL(blob);
                window.open(downloadUrl);
            })

    }
    //   downloadPDFReport(filterCriteria: any): any {
    //       let fileName = 'processBreakInReportPDFUpload?WorkYear=' + filterCriteria.selectedYear
    //           + '&ControlGroup=' + filterCriteria.selectedControlGroup;
    //       const url = this._Invoicereport + fileName
    //       const headers = new Headers();
    //       headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    //       headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    //       // headers.append('Authorization', 'JWT ' + localStorage.getItem('id_token'));
    //       return this._http.get(url, { headers: headers, responseType: ResponseContentType.Blob }).map(
    //           (res) => {
    //               const a = document.createElement('a');
    //               document.body.appendChild(a);
    //               const blob = new Blob([res.blob()], { type: 'application/zip' });
    //               const downloadUrl = URL.createObjectURL(blob);
    //               window.open(downloadUrl);
    //           })
    //   }

    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
    }

    getInvoiceReportData(data: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._Invoicereport + `v2/report-data`,data, { headers: headers })
          .map((res: Response) => res.json())
          .catch(this.handleError);
      }
}



// WEBPACK FOOTER //
// ./src/app/invoicereport/invoicereport.service.ts